import { getDomainNotificationManager } from '@repo/core'
import { takeEvery } from 'redux-saga/effects'
import {
  accountDetailDataActions,
  accountDetailDownloadActions,
  accountListDataActions,
  bankingProductMovementsDownloadActions,
  bankingProductsDataActions,
  editAliasDataActions,
  productOperationsMasterListActions,
  productOperationsMasterListDownloadActions,
  productsByTypeDataActions,
} from '../../slices'
import { httpStatusErrorCodesMapper } from './httpStatusErrorCodesMapper'

// ******************************************** //
// [ DOC ]:                                     //
// En este archivo, en el array del takeEvery   //
// se deben agregar las acciones que se quieran //
// escuchar de cara a notificar al usuario      //
// ******************************************** //

export function* watchAccountsNotifications() {
  yield takeEvery(
    [
      editAliasDataActions.putResponse.type,
      accountDetailDataActions.getResponse.type,
      accountDetailDownloadActions.downloadResponse.type,
      accountListDataActions.getResponse.type,
      accountListDataActions.refreshResponse.type,
      productOperationsMasterListActions.getResponse.type,
      productOperationsMasterListDownloadActions.downloadResponse.type,
      bankingProductMovementsDownloadActions.downloadResponse.type,
      productsByTypeDataActions.getResponse.type,
      bankingProductsDataActions.getResponse.type,
      bankingProductsDataActions.refreshResponse.type,
    ],
    getDomainNotificationManager({ domain: 'accounts', httpStatusErrorCodesMapper }),
  )
}
